<template>
  <header ref="header" class="top">
    <router-link class="me" :to="to('home')" :aria-label="t('Arolle Fona, accueil', 'Arolle Fona, home')">
      <img :src="avatar" alt="" width="40" height="40" />
    </router-link>

    <!-- Menu complet (ordinateur) -->
    <nav class="menu" :aria-label="t('Navigation principale', 'Main navigation')">
      <router-link v-for="item in menu" :key="item.key" :to="to(item.key)" :aria-current="isCurrent(item.key)">{{ t(item.label) }}</router-link>
    </nav>

    <div class="tools">
      <span class="clock" aria-hidden="true">{{ clock }}</span>
      <router-link
        class="tool lang"
        :to="otherLangPath"
        :hreflang="lang === 'en' ? 'fr' : 'en'"
        :aria-label="t('Read in English', 'Lire en français')"
        >{{ t("EN", "FR") }}</router-link
      >
      <button class="tool" type="button" :aria-label="t('Changer de thème', 'Toggle theme')" @click="toggleTheme">
        <Sun v-if="dark" />
        <Moon v-else />
      </button>
      <!-- Bouton du menu (mobile et tablette) -->
      <button
        class="tool burger"
        type="button"
        aria-controls="mobile-menu"
        :aria-expanded="open ? 'true' : 'false'"
        :aria-label="open ? t('Fermer le menu', 'Close menu') : t('Ouvrir le menu', 'Open menu')"
        @click="open = !open"
      >
        <X v-if="open" />
        <MenuIcon v-else />
      </button>
    </div>

    <nav v-show="open" id="mobile-menu" class="mnav" :aria-label="t('Navigation principale', 'Main navigation')">
      <router-link v-for="item in menu" :key="item.key" :to="to(item.key)" :aria-current="isCurrent(item.key)">
        {{ t(item.label) }}
      </router-link>
    </nav>
  </header>
</template>

<script>
import { Menu as MenuIcon, Moon, Sun, X } from "lucide-vue-next";
import { AVATAR } from "@/content";
import { MENU, useI18n } from "@/i18n";

export default {
  name: "SiteHeader",
  components: { Sun, Moon, MenuIcon, X },
  setup() {
    return { ...useI18n(), menu: MENU, avatar: AVATAR };
  },
  data: () => ({ now: new Date(), dark: document.documentElement.dataset.theme === "dark", open: false, timer: null }),
  computed: {
    clock() {
      const time = new Intl.DateTimeFormat(this.lang === "en" ? "en-GB" : "fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Africa/Douala",
      }).format(this.now);
      return time + this.t(" à Douala", " in Douala");
    },
  },
  watch: {
    // Referme le menu après chaque navigation
    $route() {
      this.open = false;
    },
  },
  mounted() {
    this.timer = setInterval(() => (this.now = new Date()), 30000);
    document.addEventListener("keydown", this.onKey);
    document.addEventListener("click", this.onClickOutside);
  },
  beforeUnmount() {
    clearInterval(this.timer);
    document.removeEventListener("keydown", this.onKey);
    document.removeEventListener("click", this.onClickOutside);
  },
  methods: {
    isCurrent(key) {
      return this.$route.meta.key === key ? "page" : null;
    },
    toggleTheme() {
      this.dark = !this.dark;
      const theme = this.dark ? "dark" : "light";
      document.documentElement.dataset.theme = theme;
      localStorage.setItem("theme", theme);
    },
    onKey(e) {
      if (e.key === "Escape") this.open = false;
    },
    onClickOutside(e) {
      if (this.open && !this.$refs.header.contains(e.target)) this.open = false;
    },
  },
};
</script>
